/**
 */
import dateTime from "core/data-types/date-time";
import MetaInfoStatus from "core/data-types/metaInfoStatus";
export default {
    dateTime: dateTime,
    MetaInfoStatus: MetaInfoStatus,
};
